import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const NumberLineSelectionsReducer = () => [];

export const NumberLineSelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(NumberLineSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(NumberLineSelectionsReducer),
};
